import { FC } from "react";
import { MiBuildPageHeader, MiButton, MiIcon } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { mdiHomeOutline, mdiPlus } from "@mdi/js";
import { useTheme } from "@mui/material";
import { AddHomeDrawer } from "../../../components/AddHomeDrawer/AddHomeDrawer";
import { useHomesAddHomeDrawer } from "../hooks/useHomesAddHomeDrawer";

export const HomesPageHeader: FC<HomesPageHeaderProps> = ({ isLoading }) => {
  const theme = useTheme();
  const {
    isDrawerOpen,
    handleDrawerOpen,
    handleDrawerClose,
    handleAfterHomeCreation,
  } = useHomesAddHomeDrawer();

  return (
    <>
      <MiBuildPageHeader
        title="Homes"
        titleIcon={
          <MiIcon
            path={mdiHomeOutline}
            size={1}
            color={theme.palette.primary.main}
          />
        }
        loading={isLoading}
        actionComponent={
          <MiButton
            title="Home"
            variant={BUTTON_VARIANTS.CONTAINED}
            startIcon={{
              path: mdiPlus,
              iconSize: 0.8,
            }}
            onClick={handleDrawerOpen}
            data-testid="add-home-button"
          />
        }
      />
      <AddHomeDrawer
        open={isDrawerOpen}
        onClose={handleDrawerClose}
        onCreate={handleAfterHomeCreation}
      />
    </>
  );
};

interface HomesPageHeaderProps {
  isLoading: boolean;
}
